/*
 * Pokitrio-Redesign 2026: Handy-Menue (snippets/pkt-drawer.liquid), unter 1100 px.
 *
 * Baut auf Impacts dialog-element (assets/theme.js) auf und erbt damit:
 *   - Oeffnen/Schliessen ueber jedes Element mit aria-controls="pkt-drawer" (Burger), aria-expanded am Burger
 *   - Fokusfalle (focus-trap aus vendor.min.js) inkl. Stapel mit anderen Impact-Dialogen (Such-Drawer,
 *     Warenkorb, Newsletter-Popup): oeffnet sich einer davon, pausiert unsere Falle und setzt danach fort
 *   - Escape schliesst, Fokus geht zurueck zum Burger (returnFocusOnDeactivate)
 *   - Body-Scroll-Sperre ueber html.lock (gemeinsamer Ebenen-Zaehler aller Impact-Dialoge)
 *   - close-button im Kopf (dialog:force-close), Theme-Editor-Ereignisse
 * Eigenes:
 *   - Ein-/Ausblenden (nur bei prefers-reduced-motion: no-preference animiert)
 *   - Akkordeon: hoechstens ein Bereich offen, Buttons mit aria-expanded/aria-controls,
 *     Pfeil hoch/runter, Pos1/Ende zwischen den Bereichskoepfen
 *   - Klick auf den Hintergrund (Tablet) schliesst; ab 1100 px (Desktop-Navigation) schliesst der Drawer
 *   - Tipp auf ein Plus (Highlight, Warenkorb ueber assets/pkt-card.js) schliesst sofort
 *   - Akkordeon-Kopf bleibt nach dem Umschalten sichtbar (scrollIntoView nearest, ohne smooth bei reduced motion)
 *   - Header-Section waehrend offen auf z-index 990 (Klasse pkt-dr-offen)
 *   - pageshow aus dem bfcache (persisted): hide()
 */
(function () {
  'use strict';

  if (window.customElements.get('pkt-drawer')) return;

  var bewegung = window.matchMedia('(prefers-reduced-motion: no-preference)');
  var desktop = window.matchMedia('(min-width: 1100px)');

  function definiere(Basis) {
    if (window.customElements.get('pkt-drawer')) return;

    class PktDrawer extends Basis {
      get shouldLock() { return true; }
      // Bleibt in der Header-Section (sticky, z-index 10): ueber dem Seiteninhalt, aber unter Impacts Overlays
      // (Such-Drawer, Warenkorb, Newsletter-Popup, z-index 999 auf Wurzelebene), die sich darueber oeffnen.
      get shouldAppendToBody() { return false; }

      // Ab 1100 px (Mega-Menue) nie oeffnen, auch nicht ueber die Section-Auswahl im Theme-Editor
      // (handle-section-events): sonst setzt Impact html.lock und sperrt das Scrollen ohne sichtbares Menue.
      show(animiert) {
        if (desktop.matches) return Promise.resolve();
        return super.show(animiert);
      }

      connectedCallback() {
        super.connectedCallback();
        if (this._pktGebunden) {
          this._medienAn();
          return;
        }
        this._pktGebunden = true;

        this.addEventListener('click', (e) => {
          var kopf = e.target.closest('[data-pkt-akk]');
          if (kopf && this.contains(kopf)) {
            this._umschalten(kopf);
            return;
          }
          if (e.target.closest('[data-pkt-dr-fond]')) this.hide();
          // Plus im Highlight (snippets/pkt-plus.liquid): Menue sofort zu, Variantenauswahl, Meldung und Warenkorb
          // (assets/pkt-card.js, Listener am document) erscheinen auf der freien Seite statt hinter der Fokusfalle
          if (e.target.closest('[data-pkt-add], [data-pkt-auswahl]')) this.hide();
        });

        this.addEventListener('keydown', (e) => {
          var kopf = e.target.closest('[data-pkt-akk]');
          if (!kopf) return;
          var alle = Array.from(this.querySelectorAll('[data-pkt-akk]'));
          var i = alle.indexOf(kopf);
          var ziel = null;
          if (e.key === 'ArrowDown') ziel = alle[(i + 1) % alle.length];
          else if (e.key === 'ArrowUp') ziel = alle[(i - 1 + alle.length) % alle.length];
          else if (e.key === 'Home') ziel = alle[0];
          else if (e.key === 'End') ziel = alle[alle.length - 1];
          if (ziel) {
            e.preventDefault();
            ziel.focus();
          }
        });

        this._beiDesktop = () => { if (desktop.matches && this.open) this.hide(); };
        this._medienAn();
      }

      // eigener connectedCallback-Teil, der bei jedem Einhaengen laeuft (Element-Listener oben nur einmal)
      _medienAn() {
        if (desktop.addEventListener) desktop.addEventListener('change', this._beiDesktop);
      }

      disconnectedCallback() {
        super.disconnectedCallback();
        if (desktop.removeEventListener) desktop.removeEventListener('change', this._beiDesktop);
      }

      _umschalten(kopf) {
        var auf = kopf.getAttribute('aria-expanded') !== 'true';
        this.querySelectorAll('[data-pkt-akk]').forEach((k) => {
          var offen = k === kopf ? auf : false;
          k.setAttribute('aria-expanded', offen ? 'true' : 'false');
          var inhalt = document.getElementById(k.getAttribute('aria-controls'));
          if (inhalt) inhalt.hidden = !offen;
        });
        // Beim Schliessen eines weiter oben offenen Bereichs rutscht der Inhalt nach oben; Safari/iOS kennt kein
        // overflow-anchor. Den angetippten Kopf deshalb im sichtbaren Bereich halten (scroll-margin-top = Kopfleiste).
        if (kopf.scrollIntoView) kopf.scrollIntoView({ block: 'nearest', behavior: bewegung.matches ? 'smooth' : 'auto' });
      }

      // Header-Section waehrend des offenen Menues anheben (z-index 990, CSS in sections/header.liquid):
      // ueber sticky Leisten, Judge.me-Badge u. a., aber unter Impacts Overlays (999: Suche, Warenkorb, Popups)
      _sectionAnheben(an) {
        var sec = this.closest('.shopify-section');
        if (sec) sec.classList.toggle('pkt-dr-offen', an);
      }

      _showTransition(animiert) {
        this.classList.add('is-sichtbar');
        this._sectionAnheben(true);
        if (animiert === false || !bewegung.matches || !this.animate) return Promise.resolve();
        var panel = this.querySelector('.pkt-dr__panel');
        var fond = this.querySelector('.pkt-dr__fond');
        var a = panel.animate([{ transform: 'translateX(-24px)', opacity: 0 }, { transform: 'none', opacity: 1 }],
          { duration: 220, easing: 'cubic-bezier(.2, .8, .2, 1)' });
        if (fond) fond.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 220 });
        return a.finished.catch(function () {});
      }

      _hideTransition() {
        var fertig = () => {
          // schnell wieder geoeffnet: die alte Schliess-Animation darf den neuen Zustand nicht abraeumen
          if (this.open) return;
          this.classList.remove('is-sichtbar');
          this._sectionAnheben(false);
        };
        if (!bewegung.matches || !this.animate) {
          fertig();
          return Promise.resolve();
        }
        var panel = this.querySelector('.pkt-dr__panel');
        var a = panel.animate([{ transform: 'none', opacity: 1 }, { transform: 'translateX(-24px)', opacity: 0 }],
          { duration: 160, easing: 'ease-in' });
        return a.finished.then(fertig, fertig);
      }
    }

    window.customElements.define('pkt-drawer', PktDrawer);

    // Zurueck-Navigation aus dem bfcache: offenes Menue samt Scroll-Sperre schliessen
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      document.querySelectorAll('pkt-drawer[open]').forEach(function (d) { d.hide(); });
    });
  }

  // dialog-element wird von theme.js (Modul) definiert; erst danach erweitern
  window.customElements.whenDefined('dialog-element').then(function () {
    definiere(window.customElements.get('dialog-element'));
  });
})();
